<script>
import Router from 'svelte-spa-router';
import { replace } from 'svelte-spa-router';
import SignIn from './components/signin.svelte';
import SignUp from './components/signup.svelte';
import SignOut from './components/signout.svelte';
import Create from './components/create.svelte';
import Verify from './components/verify.svelte';
import Home from './components/home.svelte';
import Payment from './components/payment.svelte';
import Link from './components/link.svelte';
import Order from './components/order.svelte';
import Faculty from './components/faculty.svelte';
import Contact from './components/contact.svelte';
import Reset from './components/reset.svelte';
import SigninHelp from './components/signinhelp.svelte';
import EnterYourInformation from './components/enteryourinformation.svelte';
import * as utils from './utils.js'
import * as user from './user.js';
import firebase from './firebase';
import {wrap} from 'svelte-spa-router/wrap'

// we need a way to sit and spin until we are sure there isn't a user

//http://localhost:6001/?mode=verifyEmail&oobCode=0vBIamHk04wQK63m5za7b6Ctc2BVn2Lm4mC4eqIAC-IAAAF3Heo0IA&apiKey=AIzaSyAMHHOvKsCRTqZw7RsSGHwV3X3XvOEaAig&lang=en



function CheckAuth()
{
    console.log('CheckAuth');
    return async function check(detail){
        try
        {
            const authUser = await user.GetAuthOnly();
            console.log('do I have an auth user?', authUser);
            if (authUser)
            {
                return true;
            }
        }
        catch(e)
        {
            console.log('error', e);
        }

        detail.error = 'no-session';
        return false;
    };
}

async function HasSubscription(detail)
{
    const S2P = { // State to Page
        'needsverify':'/signup/verify',
        'needsinfo':'/signup/info',
        'needspayment': '/signup/payment'
    }

    if (detail.querystring.includes('force'))
        return true;

    console.log("detail", detail);
    try
    {
        const route = detail.route;
        const u = await user.Get();
        console.log("is there a user?", u);
        if (u && u.auth)
        {
            // they are at least authenticated with google
            // now see if they have started the subscrpition process
            const state = u.signUpState;
            if (state)
            {
                if (state === 'done')
                {
                    // this should eventually just filter down to them going back home 
                }
                else
                {
                    if (route === S2P[state])
                    {
                        return true;
                    }
                    else
                    {
                        detail.goto = S2P[state];
                        return false;
                    }
                }
            }
        }
        else
        {
            if (route === '/signup/create')
            {
                console.log("allow create page");
                return true;
            }
        }
    }
    catch(e)
    {
        console.log('no user?', e);
    }


    detail.goto = '/';
    return false;

    /*
    return async function check(detail){
        try
        {
            const authUser = await user.GetAuthOnly();
            console.log('do I have an auth user?', authUser);
            if (authUser)
            {
                return true;
            }
        }
        catch(e)
        {
            console.log('error', e);
        }

        detail.error = 'no-session';
        return false;
    };
    */
}


function AuthWrap(c)
{
    return wrap({component:c, conditions:[CheckAuth()]});
}

function SignupWrap(c)
{
    return wrap({component:c, conditions:[HasSubscription]});
}

// wrap the purchase process in something else... maybe something that takes into
// consideration if they have already purchased the product or something??
// probably just look at the cart object to see if a) is exists and b) is recent enough



const routes = {
    '/':  Home,
    '/signin': SignIn,
    '/signin/help' : SigninHelp,
    '/signout': SignOut,
    '/litmosout': Home,

    '/signup/create': SignupWrap(Create),
    '/signup/verify': SignupWrap(Verify),
    '/signup/info': SignupWrap(EnterYourInformation),
    '/signup/payment': SignupWrap(Payment),

    '/order': Order,
    '/faculty': Faculty,
    '/contact': Contact,
    '/reset': Reset,
    '/link': Link
};

function routeLoading(event) {
    utils.log('Route', event.detail.route, event.detail.location, event.detail.querystring);
}

function conditionsFailed(event) {
    if (event.detail.error === 'no-session')
    {
        // redirect to the sign in page with a return to location
        let redirect = `/signin?rt=${event.detail.route}`;
        if (event.detail.querystring)
        {
            redirect += `&${event.detail.querystring}`;
        }

        replace(redirect);
    }
    else if (event.detail.goto)
    {
        replace(event.detail.goto);
    }

    console.log(event);
}

</script>

<Router routes={routes}
        on:routeLoading={routeLoading} on:conditionsFailed={conditionsFailed} />
